import React, { useEffect, useState } from 'react';
import { Box, Card, Flex, Image, Tooltip, getPaletteColor } from 'pcln-design-system';
import { Dot } from 'pcln-icons';
import styled, { keyframes, css } from 'styled-components';
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
const CircleCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "StickyChatBotOpener__CircleCard",
  componentId: "sc-ie1md5-0"
})(["width:60px;height:60px;background-color:", ";transition:0.2s ease-in-out;border:none;box-shadow:", ";&:hover{cursor:pointer;box-shadow:", ";}"], getPaletteColor('primary.base'), ({
  theme
}) => theme.shadows.md, ({
  theme
}) => theme.shadows.lg);
const StyledDot = /*#__PURE__*/styled(Dot).withConfig({
  displayName: "StickyChatBotOpener__StyledDot",
  componentId: "sc-ie1md5-1"
})(["position:absolute;right:-8px;top:-5px;"]);
const fadeInFromBottomToTopAnimation = props => {
  const animation = /*#__PURE__*/keyframes(["from{transform:translate(", ",", ");-webkit-transform:translate(", ",", ");opacity:0;}to{transform:translate(", ",", ");opacity:1;}"], props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
  return css(["position:relative;animation:", ";animation-duration:0.4s;animation-fill-mode:forwards;animation-timing-function:cubic-bezier(0,0,0.3,1);"], animation);
};
const AnimateBottomToTop = /*#__PURE__*/styled.div.withConfig({
  displayName: "StickyChatBotOpener__AnimateBottomToTop",
  componentId: "sc-ie1md5-2"
})(["", " position:absolute;bottom:0;width:100%;height:100%;"], fadeInFromBottomToTopAnimation);
const AnimateComponent = ({
  children,
  animationProperties,
  animationType
}) => {
  if (animationType === 'BottomToTop') {
    const {
      bottom,
      from,
      to
    } = animationProperties;
    return React.createElement(AnimateBottomToTop, {
      fromX: from.x,
      fromY: from.y,
      toX: to.x,
      toY: to.y,
      bottom: bottom
    }, children);
  }
  return children;
};
/**
 * StickyChatBotOpener Component
 * @public
 */
export const StickyChatBotOpener = props => {
  const {
    isChatBoxOpened,
    onComponentRendered,
    onClickHandler,
    openerPosition,
    animationType = 'None',
    animationProperties
  } = props;
  const [isTooltipOpen, setIsOpen] = useState(false);
  const [isSectionActive, setIsSectionActive] = useState(false);
  useEffect(() => {
    onComponentRendered();
  }, []);
  useEffect(() => {
    if (isChatBoxOpened && !isSectionActive) {
      setIsSectionActive(true);
    }
  }, [isChatBoxOpened]);
  function onMouseOver() {
    setIsOpen(true);
  }
  function onMouseOut() {
    setIsOpen(false);
  }
  const openerTooltipProps = props.openerTooltipProps || {};
  const tooltipProps = Object.assign({
    top: true,
    center: true,
    bg: 'black',
    color: 'white'
  }, openerTooltipProps);
  return React.createElement(AnimateComponent, {
    animationType: animationType,
    animationProperties: animationProperties
  }, React.createElement(CircleCard, {
    style: Object.assign({
      position: 'fixed',
      right: '32px',
      bottom: '32px'
    }, openerPosition),
    borderRadius: 50,
    "data-testid": 'openChatBotDialog',
    onClick: onClickHandler,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, isTooltipOpen && React.createElement(Tooltip, Object.assign({
    p: 1,
    style: Object.assign({
      bottom: '-2px'
    }, props.openerTooltipStyle)
  }, tooltipProps), React.createElement(Box, {
    width: '110px'
  }, "Chat with Penny")), React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    width: 60,
    alt: 'Penny chat opener'
  })), isSectionActive && !isChatBoxOpened && React.createElement(StyledDot, {
    size: 32,
    color: 'warning.tone'
  })));
};